import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { init, use } from 'echarts/core';
import { BarChart, LineChart } from 'echarts/charts';
import { GridComponent, LegendComponent, TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { ADMIN_CHART_KINDS, ADMIN_CHART_METRICS, buildAdminMetricsChartOption, collectBuckets, } from '@/pages/admin/ui/adminMetricsChartOption';
use([BarChart, LineChart, GridComponent, LegendComponent, TooltipComponent, CanvasRenderer]);
export function AdminMetricsChart({ series }) {
    const hostRef = useRef(null);
    const [kind, setKind] = useState('line');
    const [metric, setMetric] = useState('turnover');
    const option = useMemo(() => buildAdminMetricsChartOption(series, kind, metric), [series, kind, metric]);
    const hasData = series.length > 0 && collectBuckets(series).length > 0;
    useEffect(() => {
        const host = hostRef.current;
        if (!host || !hasData)
            return;
        const chart = init(host);
        chart.setOption(option, { notMerge: true });
        const observer = new ResizeObserver(() => chart.resize());
        observer.observe(host);
        return () => {
            observer.disconnect();
            chart.dispose();
        };
    }, [hasData, option]);
    if (!hasData) {
        return _jsx("p", { className: "admin-empty", children: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u0433\u0440\u0430\u0444\u0438\u043A\u0430" });
    }
    return (_jsxs("div", { className: "admin-chart-wrap", children: [_jsxs("div", { className: "admin-chart-toolbar", children: [_jsx("div", { className: "admin-chart-seg", role: "group", "aria-label": "\u0422\u0438\u043F \u0433\u0440\u0430\u0444\u0438\u043A\u0430", children: ADMIN_CHART_KINDS.map((item) => (_jsx("button", { type: "button", className: kind === item.id ? 'is-active' : undefined, onClick: () => setKind(item.id), children: item.label }, item.id))) }), _jsx("select", { className: "admin-select", "aria-label": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044C", value: metric, onChange: (event) => setMetric(event.target.value), children: ADMIN_CHART_METRICS.map((item) => (_jsx("option", { value: item.id, children: item.label }, item.id))) })] }), _jsx("div", { ref: hostRef, className: "admin-chart", role: "img", "aria-label": "\u041C\u0435\u0442\u0440\u0438\u043A\u0438 \u043F\u043E \u0442\u043E\u0447\u043A\u0430\u043C" })] }));
}
